const style = [
    {
        "selector":"indicator.HHLL layer.line",
        "values": {
            "line-color": "rgba(66, 66, 66, 0.2)"
        }
    },
    {
        "selector":"indicator.HHLL layer.band",
        "values": {
            "fill-color": "rgba(0, 0, 0, 0.2)"
        }
    },
    {
        "selector":"chart",
        "values": {
            "x-axis-top-style":"none",
            "background-color": "#ffffff"
        }
    },
    {
        "selector": "chart crosshair",
        "values": {
            "line-color": "rgba(0,0,0,0.38"
        }
    },
    {
        "selector":"chartset",
        "values": {
            "secondary-y-axis-placeholder":"always",
            "background-color": "#ffffff"
            // "interpolation": "nearest-neighbor"
        }
    } /* ,
    {
        "selector":"layer.line",
        "values": {
            "line-color": "#000",
            "line-width": 1
        }
    } */
];

module.exports = style;
